import React from 'react';

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.linkedin.com/in/victor-hugo-moreira-5ab559235/" className="home__social-icon" target='_blank'>
                <i class="uil uil-linkedin-alt"></i>
            </a>
            
            <a href="https://github.com/Torugo38" className="home__social-icon" target='_blank'>
                <i class="uil uil-github-alt"></i>
            </a>
        </div>
    );
};

export default Social;